export default {
    state: {
        // token: '0d3c2f3f5c62aab8770c63ddcd79206ab75a87b7',
    },

    actions: {
        async fetchLogin(ctx, params) {
            console.log(params)
            const toastWaitId = this._vm.$toast("Login ...",{timeout: 60000,})
            const requestPostOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
                body: JSON.stringify({
                    'username': params['username'],
                    'password': params['password'],
                })
            };
            const resPost = await fetch("/api/auth/token/login/", requestPostOptions)
            const res = await resPost.json();
            if ('auth_token' in res) {
                const token = res['auth_token'];
                ctx.commit('updateToken', token);
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.success("Success")
                console.log(token)
            }
            else {
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.error("Error:" + res['non_field_errors'], {timeout: 5000})
            }
        },
    },

    mutations: {
        updateToken(state, token) {
            state.token = token
        },
    },
    getters: {
        getToken(state) {
            return state.token
        },
    }
}